import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import '@/styles/index.scss' // global css
import '@/styles/theme.scss'

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/js/all.js'
import '@fortawesome/fontawesome-free/css/all.css'

import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import 'element-ui/lib/theme-chalk/display.css'
import '@/styles/element-variables.scss'

import VueMoment from 'vue-moment'
import Print from 'vue-print-nb'

import VueTimeago from 'vue-timeago'
import VueFire from 'vuefire'
import vueDebounce from 'vue-debounce'
import VueNativeNotification from 'vue-native-notification'

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})

Vue.notification.requestPermission()
  .then(console.log)

Vue.use(VueFire)

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en'// Default locale
})

Vue.use(Print)

import jQuery from 'jquery'
var $ = jQuery
window.$ = $

// The vue debounce will delay a method when call
Vue.use(vueDebounce, {
  defaultTime: '500ms'
})

Vue.use(ElementUI, { locale })
Vue.use(VueMoment)
Vue.config.productionTip = false

router.beforeResolve((to, from, next) => {
  var allowed_views = store.getters.views
  var views = allowed_views.concat(store.getters.default_views)
  if (to.name) {
    if (to.meta.group === 'POLICY') {
      if (store.getters.user_policy === true) {
        next({ path: '/' })
      } else {
        next()
      }
    } else {
      if (to.meta.group !== 'DEFAULT') {
        if (store.getters.user_policy === false) {
          next({ path: '/policy' })
        }
        if (views.indexOf('QMS') < 0) {
          store.dispatch('FedLogOut').then(() => {
            Message.error('Invalid User')
            setTimeout(function() {
              window.location.reload(1)
            }, 1000)
          })
        }
        if (views.indexOf(to.meta.group.toUpperCase()) < 0) {
          router.push('404')
        } else {
          next()
        }
      } else {
        next()
      }
    }
  }
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
